import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from 'vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import jobCategoryOptions from '@/utils/format-edit/designRirekishoJobCategoryOptions.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekishoJobCategoryCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useRirekishoFormatData()
const jobSearchQuery = ref('')
const showJobDropdown = ref(false)
const filteredJobOptions = ref<string[]>([])

function onJobSearchInput(query: string) {
  if (query !== '') {
    filteredJobOptions.value = jobCategoryOptions
      .filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) > -1)
      .slice(0, 20)
    showJobDropdown.value = true
  } else {
    filteredJobOptions.value = []
    formatData.job_category = ''
  }
}

function onJobSearchBlur() {
  setTimeout(() => {
    showJobDropdown.value = false
  }, 200)
}

function selectJobCategory(item: string) {
  formatData.job_category = item
  jobSearchQuery.value = item
  showJobDropdown.value = false
  filteredJobOptions.value = []
}

onBeforeMount(() => {
  if (formatData.job_category) {
    jobSearchQuery.value = String(formatData.job_category)
  }
})

return { __sfc: true,formatData, jobSearchQuery, showJobDropdown, filteredJobOptions, onJobSearchInput, onJobSearchBlur, selectJobCategory }
}

})